import styled from 'styled-components';

export const FilterContainer = styled.div`
  margin: 16px;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 20px;
`;

export const ButtonPanel = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;
